;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');

	View.TippingTips = View.TippingTips.extend({
		tagName: 'div',

		template: JST.ExtendedTippingTipsForAflClubs,
		data: {},

		initialize: function() {
			this.round_id          = this.getOption('round_id');
			this.rounds            = this.getOption('rounds');
			this.squads            = this.getOption('squads');
			this.venues            = this.getOption('venues');
			this.formGuide         = this.getOption('formGuide');
			this.trend             = this.getOption('trend');
			this.checksumEmitter             = this.getOption('checksumEmitter');
			this.getting_data      = false;
			this.data.margin_range = 100;
			this.matchTrend        = [];

			this.timer_circle_color = '#60686F';
			this.timer_circle_bg    = '#0f7ad2';

			this.forms = [];

			var collections = [this.rounds, this.squads, this.venues],
				complete = _.invoke(collections, 'fetch', {cache: true, expires: 60 });

			$.when.apply(null, complete).done(_.bind(this.initListeners, this));


			//this.listenTo(APP.vent, 'tipping:round:change', this.setSelectedRound());
		},

		ui: {
			tip:                  '.js-tip',
			tip_team:             '.js-tip-team',
			active_tip:           '.js-tip-team.active',
			days:                 '.days',
			form_guide_container: '.js-form-guide-container',
			save_tips:            '.js-save-tips',
			tips_count:           '.js-tips-count',
			tips_saved_msg:       '.js-tips-saved-msg',
			fill_popular:         '.js-set-popular-tips',
			fill_random_tips:     '.js-set-random-tips',
			round_match:          '.js-round-match',
			nst_slider:           '.js-nst-slider',
			//home_points:          '.js-home-points',
			margin_points:          '.js-margin-points ',
			tip_home:             '.js-tip-home',
			tip_away:             '.js-tip-away',
			tip_item:             '.round-content-area',
			print:             '.js-print-tips',
		},

		events: {
			"click @ui.tip":              "updateTipStatus",
			"click @ui.save_tips":        "saveTipList",
			'click @ui.fill_popular':     'fillPopular',
			'click @ui.fill_random_tips': 'fillLuckOfDraw',
			//'input @ui.home_points':      'updateMargin',
			'input @ui.margin_points':      'updateMargin',
			"mouseover @ui.tip_item":     "highlightTeams",
			"mouseout @ui.tip_item":      "removeHighlightTeams"
		},

		highlightTeams: function (e) {

			var $this = $(e.currentTarget),
				home = $this.find('.round-contents-left').data('predict_winner_squad_id'),
				away = $this.find('.round-contents-right').data('predict_winner_squad_id');

			$('.round-ladder').find('#squad-' + home + ', #squad-' + away).addClass('highlight')
		},

		removeHighlightTeams: function (e) {
			$('.round-ladder').find('.highlight').removeClass('highlight');
		},

		addFormGuide: function() {
			_.each($(this.ui.form_guide_container), _.bind(function(container) {
				var $container =  $(container);
				new View.TippingFromGuide({
					el:        $container,
					formGuide: this.formGuide,
					match_id:  $container.data('match_id'),
					hide_odds: true
				}).setTemplateData();
			}, this));

			return this;
		},

		updateTipStatus: function(e) {

			var $tip = $(e.currentTarget),
				data = $tip.data(),
				$margin_container = $tip.closest('.round-content-area').find('.margin-content'),
				winner_name = $tip.data('predict_winner_squad_id') ? this.selected_round.get('squad_names')[$tip.data('predict_winner_squad_id')].name : null;

			this.hideTipsSaveNotification();

			$.when.call(null, this.model.save_tip(data)).done(_.bind(function(model, response) {

				$tip.parent().find($(this.ui.tip)).removeClass('active');
				$tip.addClass('active');
				this.updateTipsCount();
				$margin_container.find('.js-win-team').html(winner_name ? winner_name + ' by ' : '');

				this.showTipsSaveNotification();

				APP.vent.trigger('updateCalc', data );

			}, this));
		},

		setSelectedRound: function(round_id) {

			var $this = this;

			if (!this.rounds.length) {
				return this;
			}

			this.round_id = _.isNumber(round_id) ? round_id : this.rounds.getActualRoundId();

			var fetching = this.collection.show_my_list().fetch({ data: { round: this.round_id } });

			$.when(fetching).done(_.bind(function() {
				this.trend.getStats(this.round_id)
					.fetch({is_project_json: true, cache: true, expires: 60 })
					.always(function (r) {
						$this.matchTrend = r;
						$this.selected_round = $this.rounds.get($this.round_id);
						$this.selected_round.setWinners();

						$this.extendSelectedRound().getUserTips().getIsMatchDraw().hidePreloader();
					});
			}, this));

			return this;
		},

		getIsMatchDraw: function() {
			this.selected_round.get('matches').forEach(function(match) {
				match.is_draw = (match.away_score==match.home_score);
			});

			return this;
		},

		getUserTips: function() {

			var user_tips = this.collection,
				_this = this;

			this.selected_round.get('matches').forEach(function(match) {
				var tip  = user_tips.get(match.id);
				if (tip) {

					match.tip_data = user_tips.get(match.id).toJSON();

					if(match.status == 'complete' && match.tip_data.predict_winner_squad_id == 0) {
						match.is_selected_away = true;
					}
					else {
						var is_home_squad = match.tip_data.predict_winner_squad_id == match.home_squad_id;
						match.is_selected_home = is_home_squad;
						match.is_selected_away = match.tip_data.predict_winner_squad_id == match.away_squad_id;
						match.tip_data.margin_value = match.tip_data.predict_margin;
						match.tip_data.margin_slider_value = _this.trimMarginValue(match.tip_data.predict_margin);

						//show in progress until status == complete
						if ( match.status == 'postmatch' ) {
							match.status = 'playing';
						}
						if (match.status !== 'scheduled' && !match.tip_data.is_correct) {
							const is_home = match.is_selected_home && match.is_home_winner;
							const is_away = match.is_selected_away && match.is_away_winner;
							match.tip_data.is_correct = is_home || is_away;
						}
					}
				}
			});

			const withZeroRound = this.rounds.toJSON()[0].id === 0;
			const round_id = withZeroRound ? this.round_id : this.round_id - 1;

			this.setTemplateData({
				image_url:      this.image_url,
				round_id:       round_id,
				rounds:         this.rounds.toJSON(),
				selected_round: this.selected_round.toJSON(),
				user_tip :      user_tips.toJSON(),
				img_url :       this.project_img_url,
				SQUADS_URL :    CONFIG.SQUADS_URL
			});

			return this;
		},

		extendSelectedRound: function() {
			if (this.selected_round.squad_names) {
				return this;
			}
			this.rounds.setSquadNames(this.round_id, this.squads);
			this.rounds.setVenuesNames(this.round_id, this.venues);
			this.rounds.setTippingTrends(this.round_id, this.matchTrend);

			return this;
		},

		setTemplateData: function(obj) {
			_.extend(this.data, obj);
			this.getting_data = true;
			this.render();
			return this;
		},
		trimMarginValue: function(value){
			return value > 100 ? 100 : value;
		},
		marginSlider: function() {
			if (!$(this.ui.nst_slider).length) {
				return this;
			}
			var $this = this;
			$(this.ui.nst_slider).nstSlider({
				"left_grip_selector": ".leftGrip",
				"value_bar_selector": ".bar",
				"value_changed_callback": function (cause, marginValue) {
					if( marginValue >= 100 ) return;
					$($this.ui.margin_points).val(marginValue);
				},
				user_mouseup_callback: function(margin) {
					$($this.ui.margin_points).val(margin).trigger('input');
				}
			});

			$this.updateSlider($(this.ui.nst_slider), $($this.ui.margin_points).val());

			$('.js-nst-slider').each(function(){
				if($(this).data('aria_disabled')) {
					$(this).nstSlider('disable');
				}
			});

			$( window ).on('resize', this.refreshMarginSlider);
		},

		updateMargin: function(e){
			var target = $(e.currentTarget),
				current_value	= target.val()
			;
			if(current_value > 200) {
				current_value = 200;
				target.val(current_value);
			}

			this.updateSliderAndTipStatus(target);

			return this;
		},

		updateSliderAndTipStatus: _.debounce(function(target){
			var container		= target.closest(this.ui.round_match),
				slider			= container.find(this.ui.nst_slider),
				selected_tip 	= target.closest('.round-content-area').find('.js-tip.active'),
				current_value	= target.val()
			;
			this.updateSlider(slider, current_value);
			this.updateTipStatus({currentTarget:selected_tip});

			return this;

		},500),

		updateSlider: function(slider, current_value){

			var $container = slider.closest('.margin-content'),
				predict_winner_squad_id = slider.closest('.round-content-area').find('.game-part.active').data('predict_winner_squad_id'),
				pts_label,
				value      = Math.abs(current_value),
				winner_name = predict_winner_squad_id ? this.selected_round.get('squad_names')[predict_winner_squad_id].name : null;

			slider.closest(this.ui.round_match).find('.game-part').data('predict_margin', value);

			pts_label = (value > 1) ? 'points' : 'point';
			$container.find('.js-points').html(value+ " " +  pts_label);
			$container.find('.js-win-team').html(winner_name ? winner_name + ' by ' : '');

			slider.nstSlider('set_position', this.trimMarginValue(current_value));

			return this;
		},

		render: function() {

			var $this = this;
			if (!this.getting_data) {
				return this;
			}

			this.$el.html(this.template(this.data));

			this.addFormGuide();

			$(this.ui.days).each(function(){
				$this.generateCercles(this);
			}, this);

			this.marginSlider();
			this.updateTipsCount();

			return $this;
		}

	});

}(window, APP, Backbone, Marionette, $, _));
